import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-rest-web-zipcode',
  templateUrl: 'configuration-rest-web-zipcode.html',
})
export class ConfigurationRestWebZipcodePage {

  public form: FormGroup;
  public firestore: any;
  zip_codes: any;
  zip_codes_temp: any;
  zip_code: any;
  zip_name: any;
  zip_price: number;
  zip_min_order: number;
  searchbar_text: string;

  //datatable
  sorts = [
    { prop: 'code', dir: 'asc' },
    { prop: 'name', dir: 'asc' }
  ];
  editing = {};
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    public viewCtrl: ViewController) {

    this.firestore = firebase.firestore();
    this.zip_codes = this.navParams.get('zip_codes');
    this.zip_codes_temp = this.navParams.get('zip_codes');
  }

  clickElement(event) {
    if (event.type == 'click') {
      if (event.column.name === 'delete') {
        this.deleteZipCode(event.row);
      }
    }
  }

  saveZipCode() {
    if (this.zip_name && this.zip_code) {
      const find = this.zip_codes.find(x => x.code === this.zip_code);
      if (find) {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('general-codigo-postal-ya-añadido'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
        return;
      }
      this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/zip_codes').add({
        'name': this.zip_name,
        'code': this.zip_code,
        'price': this.zip_price || 0,
        'min_order': this.zip_min_order || 0
      }).then(doc => {
        let data = {
          'name': this.zip_name,
          'code': this.zip_code,
          'price': this.zip_price || 0,
          'min_order': this.zip_min_order || 0,
          'UID': doc.id
        };
        this.zip_codes.push(data);
        this.zip_codes = [...this.zip_codes];
        this.configurationServices.getCP();

        let toast = this.toastCtrl.create({
          message: this.translate.instant('config-rest-codigo-postal-creado'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.zip_name = null;
        this.zip_code = null;
        this.zip_price = null;
        this.zip_min_order = null;
      });
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-rellena-todos-datos'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

  deleteZipCode(code) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('config-rest-eliminar-codigo-postal'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            //Eliminamos el elemento del array
            const found = this.zip_codes.map(function (e) { return e.UID; }).indexOf(code.UID);
            this.zip_codes.splice(found, 1);

            this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/zip_codes').doc(code.UID).delete();
            this.configurationServices.getCP();
          }
        }
      ]
    });
    alert.present();
  }

  fullHeight(value) {
    if (value) {
      let cssClasses = {
        'height-100': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'height-100': false,
      }
      return cssClasses;
    }
  }

  search(value) {
    if (value) {
      this.zip_codes = this.zip_codes_temp.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.zip_codes = this.zip_codes_temp;
    }
  }

  onSort(event) {
    var zips_array = this.zip_codes;
    switch (event.column.prop) {
      case 'code':
        if (event.newValue == 'asc') {
          zips_array.sort((a, b) => a.code.localeCompare(b.code));
        } else {
          zips_array.sort((a, b) => b.code.localeCompare(a.code));
        }
        break;
      case 'name':
        if (event.newValue == 'asc') {
          zips_array.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          zips_array.sort((a, b) => b.name.localeCompare(a.name));
        }
        break;
    }
    this.zip_codes = zips_array;
  }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rest-web/configuration-rest-web-zipcode/configuration-rest-web-zipcode.ts